
import DecommissionStatus from "~/models/enums/DecommissionStatus.enum";
import BuildIcon from '@mui/icons-material/Build';      
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; 
import AutorenewIcon from '@mui/icons-material/Autorenew';  
import ReportIcon from '@mui/icons-material/Report';
  
  export const getStatusIcon = (status: DecommissionStatus) => {
    switch (status) {
      case DecommissionStatus.PROVISIONING:
        return (
          <BuildIcon
            fontSize="small"
            sx={{ width: '20px', color: '#002B6E' }}
          />
        );
      case DecommissionStatus.ACTIVATED:
        return (
          <CheckCircleIcon
            fontSize="small"
            sx={{ width: '20px', color: '#002B6E'}}
          />
        );
      case DecommissionStatus.PRE_DECOMMISSIONING:
        return (
          <AutorenewIcon
            fontSize="small"
            sx={{ width: '20px', color: '#002B6E'}} />
        );
      case DecommissionStatus.DECOMMISSIONED:
        return (
          <ReportIcon
            fontSize="small"
            sx={{ width: '20px', color: '#781E1D'}} />
        );
      default:
        return (
          <CheckCircleIcon
            fontSize="small"
            sx={{ width: '19px', color: '#002B6E'}}/> );
    }
  };